module.exports = __webpack_public_path__ + "static/media/kpg-accountants-world-map.317f97ef.jpg";